var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"parent"},_vm._l((2),function(i){return _c('div',{key:i,staticClass:"container",class:_vm.containerClass,style:(_vm.containerStyles[i]),attrs:{"data-text":_vm.text}},[_vm._t("default")],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }